/* La fila dei rombi numerati sopra i riquadri di «Come lavoriamo»
   (`.m-rot` dei modelli): rombi da 44 più il bordo, appoggiati sul bordo
   superiore dei riquadri e uniti da un tratteggio rame; l'ultimo è pieno
   rame. La usano il Monitoraggio (tre passaggi, `ComeLavoriamo`, che è
   «use client») e il Report (cinque fasi, Server Component): per questo
   sta in un file senza direttiva e non porta stato.

   Chi la chiama dà le colonne (le stesse della griglia dei riquadri sotto,
   così ogni rombo cade al centro del suo riquadro), dove comincia e
   finisce il tratteggio e il confine sotto cui la fila sparisce: lì i
   riquadri vanno a capo e i rombi non hanno più una riga su cui stare. */
export function Rombi({ numeri, className }: { numeri: string[]; className: string }) {
  const ultimo = numeri.length - 1;
  return (
    <ol
      aria-hidden
      className={`relative z-[1] m-0 -mb-[22px] grid list-none p-0 before:absolute before:top-[22px] before:border-t before:border-dashed before:border-segnale before:content-[''] ${className}`}
    >
      {numeri.map((n, i) => (
        <li key={n} className="flex justify-center">
          <span
            className={`grid size-[46px] rotate-45 place-items-center border ${
              i === ultimo ? "border-segnale bg-segnale text-bg" : "border-mare bg-bg text-mare"
            }`}
          >
            <span className="-rotate-45 font-mono text-meta">{n}</span>
          </span>
        </li>
      ))}
    </ol>
  );
}
